import {styled} from "styled-components";

const TitleRowTd = styled.td<{hide?: boolean}>`
  font-weight: bold;
  background-color: #f0f0f0;
  padding: 0.5em;

  ${({hide}) =>
    hide &&
    `
      color: lightgray;
      background-color: transparent;
      padding: 0;
    `}
`;

export default TitleRowTd;
